import {
   AfterViewInit,
   Component,
   ComponentRef,
   EventEmitter,
   Input,
   OnInit,
   Output,
   TemplateRef,
   ViewChild
} from '@angular/core';
import {DxPopupComponent} from "devextreme-angular";
import {PositionConfig} from "devextreme/animation/position";

export class PopupButtonItem {
   text: string = ""
   key: string = ""
   cssClass?: string = ""
   onClick?: (popup: PopupGenericComponent)=>any
}

export enum PopupSchedaColor {
   VIOLA = "#DCC7FF",
   GIALLO = "#D4D700",
   CELESTE = "#9EF0F0",
   GRIGIO = "#D8D0CF",
   ROSA = "#EB9EB1",
   ARANCIONE = "#FFB078",
   BLU = "#0F62FE",
}

export enum PopupTextColor {
   BIANCO = "#ffffff",
   NERO = "#000000",
}

@Component({
   selector: 'app-popup-generic',
   templateUrl: './popup-generic.component.html',
   styleUrls: ['./popup-generic.component.scss']
})
export class PopupGenericComponent implements OnInit, AfterViewInit {

   @ViewChild("dxPopup") dxPopup!: DxPopupComponent

   @Input() buttons: ( null | PopupButtonItem )[] = [
      {text: "OK", key: "ok"}
   ]

   @Input() mode: "rb" | "normal" = "normal"
   @Input() autoclose=true
   @Input() title=""
   @Input() subtitle=""
   @Input() content: TemplateRef<any> | null = null;
   @Input() visible = false
   @Input() height = 'calc(100% - 161px)'
   @Input() width = 'calc(100% - 223px)'
   @Input() sizeAuto = false
   @Input() schedaColor = PopupSchedaColor.GRIGIO
   @Input() textColor = PopupTextColor.NERO
   @Input() no_animation = false;

   @Output() visibleChange = new EventEmitter<boolean>();
   @Output() onShowing: EventEmitter<any> = new EventEmitter<any>()
   @Output() onHiding: EventEmitter<any> = new EventEmitter<any>()
   @Output() onClick: EventEmitter<{ button:PopupButtonItem, component: PopupGenericComponent }> =
      new EventEmitter<{ button:PopupButtonItem, component: PopupGenericComponent }>()

   showTitle: any;
   position: PositionConfig = { my: 'center', at: 'center'}
   componentClass = "app-dx-dialog"
   dxPopupVisible = false;

   constructor() {
   }

   ngOnInit(): void {

      if(this.sizeAuto && this.mode != "rb"){
         this.width = "auto"
         this.height = "auto"
      }

      // fix bug animazione per modal aperta 2 volte con datagrid innestata nel template
      if (this.no_animation) {
         this.dxPopup.animation = {};
      }
      this.showTitle = this.mode == "normal"
      if(this.mode == "rb"){
         this.position = { my: 'right bottom', at: 'right bottom'}
      }
      if(!this.showTitle){
         this.componentClass += " app-dx-dialog-with-title"
      }
   }

   ngAfterViewInit(): void {
      setTimeout(()=>{
         if(this.buttons.length < 2){
            this.buttons = [null, ...this.buttons]
         }
      }, 10)
   }

   popupShowing(popup: DxPopupComponent) {
      this.dxPopupVisible = true
      this.onShowing.emit()
      this.visibleChange.emit(true)
   }

   popupHiding() {
      this.onHiding.emit()
      this.visibleChange.emit(false)
      setTimeout(()=>{
         this.dxPopupVisible = false
      }, 300)
   }

   clickButton(item: PopupButtonItem) {
      if(this.autoclose){
         this.visible = false;
         this.visibleChange.emit(false)
      }
      if(item.onClick){
         item.onClick(this)
      }
      this.onClick.emit({
         button: item,
         component: this
      })
   }

   close(){
      this.visible = false;
      this.visibleChange.emit(false)
   }
}
